/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_SubmittingInputs */

const en_claims_submitting = /** @type {(inputs: Claims_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting...`)
};

const fr_claims_submitting = /** @type {(inputs: Claims_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumission en cours...`)
};

/**
* | output |
* | --- |
* | "Submitting..." |
*
* @param {Claims_SubmittingInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_submitting = /** @type {((inputs?: Claims_SubmittingInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_SubmittingInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_submitting(inputs)
	return fr_claims_submitting(inputs)
});